<script>
export default {
  name: 'AiChat',
  data() {
    return {
      url: 'https://ai.youmatech.com'
    }
  }
}
</script>

<template>
  <div class="g-ai">
    <iframe :src="url" width="100%" height="100%" frameborder="0" style="margin-top: -54px;" />
  </div>
</template>

<style scoped lang="scss">
.g-ai{
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
</style>
